import React from "react";
import Select from "react-select";

const selectStyles = {
  container: (base) => ({ ...base, width: "100%" }),
  control: (base, state) => ({
    ...base,
    width: "100%",
    borderRadius: 10,
    borderColor: state.isFocused ? "#142032" : "#b5c0d4",
    boxShadow: state.isFocused ? "0 0 0 1px #142032" : "none",
    minHeight: 42,
    backgroundColor: "#f8faff",
    "&:hover": { borderColor: "#142032" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 10px" }),
  indicatorsContainer: (base) => ({ ...base, minHeight: 42 }),
  placeholder: (provided) => ({ ...provided, color: "#8f8aa6" }),
  menu: (base) => ({ ...base, zIndex: 30 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#142032" : state.isFocused ? "#f2f5fb" : "#fff",
    color: state.isSelected ? "#fff" : "#142032",
  }),
};

export default function GetMerchants({
  merchants = [],
  value = '',
  onChange,
  disabled = false,
  name = 'merchant',
  placeholder = 'Seleccione un merchant',
  noOptionsMessage = 'No hay merchants disponibles',
  maxWidth = '100%',
  style = {},
}) {
  const options = merchants.map((merchant) => ({
    value: merchant.name,
    label: merchant.name,
  }));

  const selectedOption = options.find((option) => option.value === value) || null;

  const handleChange = (selected) => {
    const nextValue = selected?.value || '';
    if (!onChange) return;

    onChange({
      persist: () => {},
      target: {
        name,
        value: nextValue,
      },
    });
  };

  return (
    <div style={{ width: '100%', maxWidth, ...style }}>
      <Select
        classNamePrefix="cashea-merchant-select"
        isSearchable
        isDisabled={disabled}
        options={options}
        value={selectedOption}
        placeholder={disabled && !merchants.length ? noOptionsMessage : placeholder}
        noOptionsMessage={() => noOptionsMessage}
        onChange={handleChange}
        styles={selectStyles}
      />
    </div>
  );
}
